import {
  REQUEST_UPI_VERIFY_VPA,
  RECEIVE_UPI_VERIFY_VPA,
  RECEIVE_ERROR_UPI_VERIFY_VPA,
  REQUEST_UPI_MERCHANT_COLLECT_DATA,
  RECEIVE_UPI_MERCHANT_COLLECT_DATA,
  RECEIVE_ERROR_UPI_MERCHANT_COLLECT
} from "../actions/upi";

const defaultUpiState = {
  vpa: "",
  payapp: "",
  trsUuid: undefined,
  isLoading: false,
  isPolling: false,
  errorMsg: undefined,
  customerName: undefined
};

export default function upiReducer(state = defaultUpiState, action) {
  switch (action.type) {
    case REQUEST_UPI_VERIFY_VPA:
      return {
        ...state,
        isLoading: true
      };
    case RECEIVE_UPI_VERIFY_VPA:
      return {
        ...state,
        isLoading: false,
        vpa: action.vpa,
        customerName: action.customerName,
        errorMsg: undefined
      };
    case RECEIVE_ERROR_UPI_VERIFY_VPA:
      return {
        ...state,
        isLoading: false,
        vpa: undefined,
        errorMsg: action.errorMsg
      };
    case REQUEST_UPI_MERCHANT_COLLECT_DATA:
      return {
        ...state,
        isLoading: true
      };
    case RECEIVE_UPI_MERCHANT_COLLECT_DATA:
      return {
        ...state,
        isLoading: true,
        isPolling: true,
        errorMsg: undefined,
        trsUuid: action.trsUuid,
        payapp: action.payapp
      };
    case RECEIVE_ERROR_UPI_MERCHANT_COLLECT:
      return {
        ...state,
        isLoading: false,
        errorMsg: action.errorMsg
      };
    default:
      return state;
  }
}
